import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Authentification from './pages/Authentification';
import Converse from './pages/Converse';
import Liveboard from './pages/Liveboard';
import MainLayout from './layouts/MainLayout';
import Usecases from './pages/Usecases';
import Auditrails from './pages/Auditrails';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Authentification />} />
        <Route path="/dashboard" element={<MainLayout />}>
          <Route index element={<Converse />} />
          <Route path="liveboard" element={<Liveboard />} />
          <Route path="usecases" element={<Usecases />} />
          <Route path="auditrails" element={<Auditrails />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
